module.exports = " <modal :click-overlay-close=false :show.sync=show :title=title> <div class=vc-prompt-content v-el:content> <div class=vc-prompt-text>{{msg}}</div> <div class=vc-prompt-text-field :class=\"{'focus-state': focus, 'not-empty-state': input}\"> <input type=text v-el:input @focus=\"this.focus = true\" @blur=\"this.focus = false\" class=vc-prompt-input v-model=input> </div> </div> <button slot=footer text=取消 @click=cancel></button> <button slot=footer text=确定 @click=sure></button> </modal> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modal/prompt.vue
 ** module id = 466
 ** module chunks = 1
 **/